/** @format */

import { selectProductReviewRating, selectProductReviewState } from './product-reviews.selector';

import { createSelector } from '@ngrx/store';

export const selectProductReviewsProsConsState = createSelector(
	selectProductReviewState,
	(state) => state.productReviewsProsConsState
);

/**
 * @description
 * Handles selecting the pros of the product reviews
 * It filters out the duplicate cons in case the BV's API returns duplicates.
 */
export const selectProductReviewPros = createSelector(
	selectProductReviewsProsConsState,
	(state) => {
		if (Array.isArray(state?.pros)) {
			const unique = new Set();
			return state.pros
				.filter((pro) => {
					if (unique.has(pro.feature)) {
						return false;
					}
					unique.add(pro.feature);
					return true;
				})
				.sort((a, b) => b.reviewsMentioned.total - a.reviewsMentioned.total);
		}
		return [];
	}
);

/**
 * @description
 * Handles selecting the cons of the product reviews.
 * It filters out the duplicate cons in case the BV's API returns duplicates.
 * It returns empty cons if there are no pros and the rating is 4 or more
 */
export const selectProductReviewCons = createSelector(
	selectProductReviewsProsConsState,
	selectProductReviewPros,
	selectProductReviewRating,
	(state, pros, rating) => {
		if (pros.length === 0 && rating >= 4) {
			return [];
		}
		if (Array.isArray(state.cons)) {
			const unique = new Set();
			return state.cons
				.filter((con) => {
					if (unique.has(con.feature)) {
						return false;
					}
					unique.add(con.feature);
					return true;
				})
				.sort((a, b) => b.reviewsMentioned.total - a.reviewsMentioned.total);
		}
		return [];
	}
);

/**
 * @description Selects the first 3 highly rated features
 */
export const selectHighlyRatedFeatures = createSelector(selectProductReviewPros, (pros) => {
	if (!Array.isArray(pros)) {
		return [];
	}
	return pros.slice(0, 3);
});

/**
 * @description Returns the selected feature
 */
export const selectSelectedFeature = createSelector(
	selectProductReviewsProsConsState,
	(state) => state.selectedFeature
);
